import { z } from 'zod/v4';

export const timeToActivationSchema = z.object({
  year: z.number(),
  month: z.number(),
  average: z.number(),
  numberOfAssetsInResult: z.number(),
});

export type TimeToActivation = z.infer<typeof timeToActivationSchema>;
